
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const ValoGuideCTA = () => {
  const handleMailClick = () => {
    const subject = "Demande d'informations - ValoGuide";
    const body = `Bonjour,

Je souhaiterais obtenir des informations complémentaires concernant vos services de valorisation des déchets.

Cordialement`;
    
    const mailtoLink = `mailto:contactgfe@groupefabre.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <section className="py-16 bg-gradient-to-br from-fabre-green to-green-700 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
          Besoin de Conseils Personnalisés ?
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
          Nos experts sont à votre disposition pour vous accompagner dans votre démarche 
          de valorisation des déchets et vous proposer des solutions sur mesure.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Button 
            onClick={handleMailClick}
            size="lg" 
            className="bg-white text-fabre-green hover:bg-gray-100 font-medium shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <Mail className="w-4 h-4 mr-2" />
            Envoyer par Mail
          </Button>
          <Button asChild size="lg" className="bg-white text-fabre-green hover:bg-gray-100 font-medium shadow-lg hover:shadow-xl transition-all duration-300">
            <Link to="/contact">Nous Contacter</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-fabre-green font-medium shadow-lg hover:shadow-xl transition-all duration-300">
            <Link to="/sites">Nos Sites</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ValoGuideCTA;
